import { render } from "./ModalPreviewMail.vue?vue&type=template&id=5aedc38c&scoped=true"
import script from "./ModalPreviewMail.vue?vue&type=script&lang=js"
export * from "./ModalPreviewMail.vue?vue&type=script&lang=js"

import "./ModalPreviewMail.vue?vue&type=style&index=0&id=5aedc38c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aedc38c"]])

export default __exports__